export enum LOCAL {
  CURRENT_USER = 'PH__u_data',
  ROLE_USER = 'PH__role',
  GROUP_USER = 'PH__group',
  RESPONSE_GROUP_USER = 'PH__group_response',
  EMAIL = 'PH__re',
  JWTOKEN = 'PH__t',
  SESSID = 'PH__SESSID',
  LOCALE = 'PH__lang_locale',
  REMEMBER_ME = 'PH__remember',
  TOKEN = 'PH__st',
  TABLE_PARTNERS = 'PH__partners',
  TABLE_PRODUCTS = 'PH__products',
  TABLE_PARTNER_PRODUCTS = 'PH__partner_products',
  TABLE_ADMIN_PLANS = 'PH__admin_plans',
  TABLE_APPROVAL_PARTNERS = 'PH__partner_approval',
  TABLE_TAB_SHORT_CODES = 'PH__tab_short_codes',
  TABLE_TAB_SSM_USERS = 'PH__tab_ssm_users',
  TABLE_TAB_DOCUMENTATION = 'PH__tab_documentation',
  TABLE_TAB_MAIN_INFO = 'PH__tab_main_info',
  TABLE_APPROVALS_PRODUCT_OFFERS = 'PH__approvals_product_offers',
  TABLE_OFFERS = 'PH__offers',
  TABLE_LEGAL_LOCAL = 'PH__legal_local',
  TABLE_CONTACTS_PERSONS = 'PH__contacts_persons',
  TABLE_TAB_DOCUMENTS = 'PH__documents',
  TABLE_PRODUCT_OFFERS = 'PH__product_offers',
  TABLE_PAYMENTS = 'PH__payments',
  TABLE_TRANSACTIONS = 'PH__transactions',
  TABLE_SETTLEMENT = 'PH__settlement',
  TABLE_OPEN_TICKETS = 'PH__open_tickets',
  TABLE_BUNDLES = 'PH__bundles',
  TABLE_PACKAGES = 'PH__packages',
  TABLE_OFFER_CAMPAIGNS = 'PH__offer_campaigns',
  TABLE_BUNDLE_PRODUCTS = 'PH__bundle_products',
  TABLE_BUNDLE_OFFER_COEXISTANCE = 'PH__bundle_offer_coexistance',
  TABLE_MASSIVE_CONFIG_APPROVE = "PH__massive_config_approve",
  TABLE_MASSIVE_CONFIG_LIST = "PH__massive_config_list",
  TABLE_VOUCHERS_LIST = "PH__vouchers_list",
  TABLE_BUNDLE_OFFER_DISABLED = 'PH__bundle_offer_disabled',
  TABLE_NO_COEXISTENCE = "PH__no_coexistence_list",
  FLAG_OFFER_LINE_FIXED = 'PH__offer_line_fixed',
  TABLE_PROD_CONST_INACTIVE_LIST = 'PH__prod_const_inactive_list'
}
